<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header">Risk Alert Detail</h3>
    <button
      type="button"
      class="close"
      ngbAutoFocus
      (click)="close()"
      (keydown.enter)="close()"
      (keydown.space)="close()"
      aria-label="Close Risk Alert Detail Modal"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body" role="document" tabindex="0">
    <h4>{{ alert.title }}</h4>
    <p><strong>Category:</strong> {{ alert.category }}</p>
    <p><strong>Risk Level:</strong> {{ alert.risk }}</p>
    <p>{{ alert.description }}</p>
  </div>
</div>
